<div class="_search-client-component">

	<div class="_search-client-container">
		<!-- SEARCH FIRSTNAME -->
        <div class="_input-container">
            <ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
            <input 
                id="firstname-input"
                [ngClass]="{'_has-results': searchResults.length > 0}" 
                (input)="autocomplete({firstname: $any($event).target.value})" 
                type="text" 
                autocomplete="no-auto" 
                placeholder="{{'CLIENT.FIRSTNAME_PLACEHOLDER' | translate}}"
            >
            <div class="_status">
                <ng-container *ngIf="loading; else result">
                    <ion-spinner name="dots"></ion-spinner>
                </ng-container>
                <ng-template #result>
                    <ion-icon *ngIf="error" class="_invalid" src="./assets/icons/invalid-input.svg"></ion-icon>
                </ng-template>
            </div>
        </div>
        
		<!-- SEARCH LASTNAME -->
        <div class="_input-container">
            <ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
            <input 
                id="lastname-input"
                [ngClass]="{'_has-results': searchResults.length > 0}" 
                (input)="autocomplete({lastname: $any($event).target.value})" 
                type="text" autocomplete="no-auto" 
                placeholder="{{'CLIENT.LASTNAME_PLACEHOLDER' | translate}}"
            >
            <div class="_status">
                <ng-container *ngIf="loading; else result">
                    <ion-spinner name="dots"></ion-spinner>
                </ng-container>
                <ng-template #result>
                    <ion-icon *ngIf="error" class="_invalid" src="./assets/icons/invalid-input.svg"></ion-icon>
                </ng-template>
            </div>
        </div>
        
        <!-- SEARCH RESULTS -->
        <div class="_search-results" *ngIf="searchResults.length > 0">
            <div class="_search-result" *ngFor="let client of searchResults" (click)="onClientSelected(client)">
                <p class="_name">{{client.firstname}} {{client.lastname}}</p>
                <p class="_address" *ngIf="client.Address">{{client.Address | address}}</p>
            </div>
        </div>
    </div>
	
</div>